import { axiosInstance } from '../utils/axiosinstance';

export interface Countdown {
  _id: string;
  title: string;
  date: string;
  status: string;
  createdAt: string;
  updatedAt: string;
}

export interface CountdownResponse {
  success: boolean;
  message?: string;
  data?: Countdown;
}

export interface CountdownsResponse {
  success: boolean;
  message?: string;
  data: Countdown[];
}

export interface CreateCountdownRequest {
  title: string;
  date: string;
}

export interface UpdateCountdownRequest {
  title?: string;
  date?: string;
}

export const countdownApi = {
  // GET /countdowns - Get all countdowns
  getCountdowns: async (): Promise<CountdownsResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.get('/api/v1/countdowns', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // POST /countdowns - Create new countdown
  createCountdown: async (data: CreateCountdownRequest): Promise<CountdownResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.post('/api/v1/countdowns', data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // PATCH /countdowns/{id}/activate - Activate countdown
  activateCountdown: async (id: string): Promise<CountdownResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.patch(`/api/v1/countdowns/${id}/activate`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // PATCH /countdowns/{id}/deactivate - Deactivate countdown
  deactivateCountdown: async (id: string): Promise<CountdownResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.patch(`/api/v1/countdowns/${id}/deactivate`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },

  // PUT /countdowns/{id} - Update countdown
  updateCountdown: async (id: string, data: UpdateCountdownRequest): Promise<CountdownResponse> => {
    const token = localStorage.getItem('adminToken');
    const response = await axiosInstance.put(`/api/v1/countdowns/${id}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  },
};
